import axios from "axios";
import { doc, setDoc } from "firebase/firestore";
import { db } from "../config/firebase";

const baseUrl = "https://us-central1-bindoo-collectives.cloudfunctions.net/api/meter/" 

export function StartSession() { 
    return null;
}

export function EndSession(authcode) {
    return axios.get(baseUrl + "end/session/" + authcode).then(res => res.data)
}

export async function ChargeTransaction(val) {

    return await setDoc(doc(db, 'sessions/xVvJ0cgMw4Y1xItNteiSF15fn5O2'), { total_items: val }, { merge: true })
}

export async function RefundTransaction(val) {

    return await setDoc(doc(db, 'sessions/xVvJ0cgMw4Y1xItNteiSF15fn5O2'), { total_items: val }, { merge: true })
}

export function GetSession(storeId) {
    return axios.get(baseUrl + "store-session?store=" + storeId).then(res => res.data)
}